enum Events {
  QuizStart = 'quizStart',
};

export default Events;
